"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FabricMapLayer_1 = require("../../components/layers/FabricMapLayer");
const roundNumericLabelText = (layer, propertyName, roundingApproach) => {
    const sourceFeatures = layer.type === "Feature" ? [layer] : layer.features;
    sourceFeatures.forEach((feature) => {
        var _a;
        if (typeof ((_a = feature.properties) === null || _a === void 0 ? void 0 : _a[propertyName]) === "number") {
            let approach;
            let significantFigures = undefined;
            if (typeof roundingApproach === "object") {
                approach = roundingApproach.approach;
                significantFigures = roundingApproach.significantFigures;
            }
            else {
                approach = roundingApproach || FabricMapLayer_1.RoundingApproach.NONE;
            }
            switch (approach) {
                case FabricMapLayer_1.RoundingApproach.UP:
                    feature.properties[propertyName] = Math.ceil(feature.properties[propertyName]);
                    break;
                case FabricMapLayer_1.RoundingApproach.DOWN:
                    feature.properties[propertyName] = Math.floor(feature.properties[propertyName]);
                    break;
                case FabricMapLayer_1.RoundingApproach.NORMAL:
                    feature.properties[propertyName] = Math.round(feature.properties[propertyName]);
                    break;
                case FabricMapLayer_1.RoundingApproach.SIGNIFICANT_FIGURES:
                    if (significantFigures !== undefined) {
                        const value = feature.properties[propertyName];
                        const factor = Math.pow(10, Math.round(Math.abs(significantFigures)));
                        feature.properties[propertyName] =
                            Math.round(value * factor) / factor;
                    }
                    break;
                default:
                    break;
            }
        }
    });
};
exports.default = { roundNumericLabelText };
